module.exports = __webpack_public_path__ + "img/Archiv_2020.5a1c1870.jpeg";